export const AppConstant = {
  DATE_FORMAT: "dd/MM/yyyy",
  USER_KEY: "auth-token",
  API_DATE_FORMAT: "YYYY-MM-DD",
  API_DATETIME_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  SEARCH_API_DATETIME_FORMAT: "YYYY-MM-DDT00:00:00",
  TIME_DISPLAY_FORMAT: "HH:mm",
  DATE_DISPLAY_FORMAT: "ddd,DD MMM YYYY",
  DATE_TIME_DISPLAY_FORMAT: "ddd,DD MMM YYYY HH:mm",
  DAY_DISPLAY_FORMAT: "ddd",
};

export const FIX_DEP_API_COLOR_CODING = {
  goflysmart: "#00bcd4",
  flybihar: "#d49a00",
  airiq: "#800080",
  algoSpin: "#f7b2d8",
  tfnexus: "#ff0000",
};
